module.exports = __webpack_public_path__ + "img/spin_btn.21d34915.png";